module.exports = "<section>\n  <h1>{{ 'kiosk.home.title' | translate }}</h1>\n  <kiosk-user-login></kiosk-user-login>\n  <feedback-message\n    class=\"-info\"\n    [text]=\"'kiosk.home.feedback_message' | translate\"\n    [closable]=\"false\">\n  </feedback-message>\n</section>"


//////////////////
// WEBPACK FOOTER
// ./ng2/kiosk/kiosk-home/kiosk-home.component.html
// module id = 1260
// module chunks = 0